const bundle = {
  close: () => 'Tutup',
  error: () => 'Ralat',
  warn: () => 'Amaran',
  info: () => 'Maklumat',
  confirmation: () => 'Pengesahan',
  progressIndeterminate: () => 'Dalam Proses',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Antara ' + p['FROM_SECTION'] + ' dengan ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Tiada seksyen yang sepadan ditemui.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Tekan Enter untuk memilih nilai.',
  indexer_touchInstructionText: () =>
    'Ketik dua kali dan tahan untuk memasuki mod gerak isyarat, kemudian seret ke atas atau ke bawah untuk melaraskan nilai.',
  inputPassword_show: () => 'Tunjukkan Kata Laluan',
  inputPassword_hide: () => 'Sembunyikan Kata Laluan',
  inputPassword_hidden: () => 'Kata Laluan Disembunyikan',
  formControl_clear: () => 'Kosongkan',
  formControl_loading: () => 'Memuatkan',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Panjang maksimum ' + p['MAX_LENGTH'] + ' dicapai.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' aksara lagi.',
  select_noMatchesFound: () => 'Tiada padanan ditemui.',
  select_oneMatchFound: () => 'Satu padanan ditemui',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' padanan ditemukan',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' atau lebih padanan ditemukan',
  selectMultiple_showSelectedValues: () => 'Tunjukkan nilai yang dipilih sahaja.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' nilai dipilih.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'Kotak semak ditanda',
  selector_unselected: () => 'Kotak semak tidak ditanda',
  userAssistance_learnMore: () => 'Ketahui lebih lanjut',
  userAssistance_required: () => 'Diperlukan',
  filePicker_singleFileUploadError: () => 'Muat naik satu fail pada satu-satu masa',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Anda tidak boleh memuat naik fail jenis ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Anda tidak boleh memuat naik fail jenis: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'tidak diketahui',
  filePicker_dropzonePrimaryText: () => 'Seret dan Lepaskan',
  filePicker_dropzoneSecondaryText: () => 'Pilih fail atau lepaskan satu fail di sini',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pilih atau lepaskan fail di sini',
  filePicker_addFiles: () => 'Tambah Fail',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Tambahkan',
  inputNumber_decrease: () => 'Kurangkan',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => 'Tiada item untuk dipaparkan',
  message_navigationFromMessagesRegion: () =>
    'Memasuki rantau mesej. Tekan F6 untuk menavigasi kembali ke elemen yang difokuskan sebelum ini.',
  message_navigationToMessagesRegion: () =>
    'Rantau mesej mengandungi mesej baru. Tekan F6 untuk menavigasi ke rantau mesej yang terkini.',
  messageToast_allMessagesClosed: () => 'Semua mesej maklum balas ditutup.'
};
export default bundle;
